<template>
  <div class="seller-management" style="padding-top: 44px;">
    <backer-header title="商品管理" />
    <ul class="tabs">
      <li :class="{active: active === 0}" @click="changeTab(0)">待审核<i></i></li>
      <li :class="{active: active === 1}" @click="changeTab(1)">已上架<i></i></li>
      <li :class="{active: active === 2}" @click="changeTab(2)">已下架<i></i></li>
      <li :class="{active: active === 3}" @click="changeTab(3)">审核被拒<i></i></li>
    </ul>
    <scroll clickable ref="scroll" class="scroll" @scrollToEnd="scrollToEnd" :is-finished="finished">
      <div class="goods" v-for="(item, index) in list" :key="item.id">
        <div class="info">
          <div class="img" :style="{backgroundImage: `url(${item.thumb_urls.split(',')[0]})`}"></div>
          <div class="right">
            <h4 class="van-multi-ellipsis--l2">{{ item.title }}</h4>
            <div class="size">
              <span>{{ item.category.title }}</span>
              <span>已售{{ item.sale_count }}件</span>
            </div>
            <p class="price">¥{{ item.price }}</p>
          </div>
        </div>
        <div class="btns">
          <button @click="toggleGoods(item.id, index)" v-if="active===1 || active===2">{{ active === 1 ? '下架商品' : '上架' }}</button>
          <!-- <button>编辑商品</button> -->
        </div>
      </div>
    </scroll>
  </div>
</template>

<script>
import BackerHeader from '../../components/back-header/back-header'
import Scroll from '../../components/scroll/scroll'
import { post } from '../../common/js/http'

const PAGE_SIZE = 10

export default {
  name: 'seller-management',
  components: {
    BackerHeader,
    Scroll
  },
  data() {
    return {
      active: 0,
      list: [],
      page: 1,
      loading: false,
      finished: true
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    toggleGoods(id, index) {
      const loading = this.$toast.loading()
      post('/shop/shop/setGoodsSaleStatus', {
        status: this.active === 1 ? 2 : 1,
        goodsid: id
      })
        .then(() => {
          this.list.splice(index, 1)
          loading.close()
          this.$nextTick(() => {
            this.$refs.scroll.refresh()
          })
        })
        .catch(() => {
          setTimeout(() => {
            loading.close()
          }, 1000)
        })
    },
    changeTab(tab) {
      if (tab === this.active) return
      this.active = tab
      this.page = 1
      this.list = []
      this.getList()
    },
    scrollToEnd() {
      if (this.loading) return
      this.loading = true
      this.page++
      this.getList()
    },
    getList() {
      let loading = null
      if (this.page === 1) {
        loading = this.$skeLoading('.seller-management', '100px')
      }
      post('/shop/shop/getShopGoods', {
        type: this.active,
        page: this.page,
        size: PAGE_SIZE
      })
        .then(({ data: { data } }) => {
          this.list = this.list.concat(data)
          this.finished = data.length < PAGE_SIZE
          loading && loading.close()
          this.$nextTick(() => {
            this.$refs.scroll.refresh()
            this.loading = false
          })
        })
        .catch(() => {
          loading && loading.close()
        })
    }
  }
}
</script>

<style scoped lang="stylus">
.seller-management
  height 100%
  box-sizing border-box
  background #f4f4f4
  .tabs
    display flex
    height 102px
    background #fff
    &>li
      flex 1
      padding-top 42px
      text-align center
      font-size 26px
      color #000000
      &.active
        &>i
          background #FD255C
      &>i
        display block
        width 22px
        margin 0 auto
        margin-top 28px
        height 7px
        border-radius 4px
        background transparent
  .scroll
    height calc(100% - 102px)
  .goods
    margin-top 20px
    padding 34px 30px 17px 30px
    background #fff
    .info
      display flex
      .img
        margin-right 26px
        width 176px
        min-width 176px
        height 176px
        border-radius 5px
        background-size cover
        background-position center center
        background-repeat no-repeat
      .right
        flex 1
        display flex
        flex-direction column
        justify-content space-between
        &>h4
          line-height 32px
          font-size 26px
          color #000000
        .size
          display flex
          justify-content space-between
          font-size 24px
          color #A0A0A0
        .price
          font-weight bold
          font-size 30px
          color #000000
    .btns
      margin-top 19px
      display flex
      justify-content flex-end
      &>button
        width 140px
        height 52px
        border-radius 26px
        border 1px solid #B9B9B9
        font-size 24px
        color #000000
        background transparent
        margin-left 12px
</style>
